import React, { Fragment, ReactNode } from 'react';
import { ICONS_MAP, IconsMapType } from './icons-mapper';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
type DivProps = React.HTMLProps<HTMLDivElement>;

const IconSize = {
  micro: 8,
  tiny: 12,
  xs: 16,
  sm: 20,
  md: 24,
  lg: 32,
  xl: 40,
};

const createIconVariantStyles = {
  rounded: 'border rounded-full',
  square: 'border rounded',
  default: '',
};

type Props = (ButtonProps | DivProps) & {
  size?: keyof typeof IconSize;
  state?: keyof typeof createIconVariantStyles;
  icon: string;
  className?: React.HTMLProps<HTMLElement>['className'];
  as?: 'button';
  onClick?: () => void;
};

export const SnapIcon = (props: Props) => {
  const {
    size = 'sm',
    state = 'default',
    icon,
    className = '',
    as,
    onClick,
    ...rest
  } = props;
  const style = `${createIconVariantStyles[state]}`;
  let iconElement: ReactNode;
  if (Object.keys(ICONS_MAP).includes(icon)) {
    const Icon = ICONS_MAP[icon as IconsMapType];
    iconElement = <Icon size={IconSize[size]} title={icon} />;
  } else {
    iconElement = <span>{icon}</span>;
  }

  return (
    <Fragment>
      {as === 'button' || onClick ? (
        <button
          type='button'
          className={`snap-button-icon relative inline-flex justify-center align-middle ${style} ${className}`}
          onClick={onClick}
          {...(rest as ButtonProps)}
        >
          {iconElement}
        </button>
      ) : (
        <div
          className={`relative inline-flex justify-center align-middle ${className}`}
          {...(rest as DivProps)}
        >
          {iconElement}
        </div>
      )}
    </Fragment>
  );
};
